module.exports = __webpack_public_path__ + "static/media/performance.36327dad.svg";